// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class CableModelNomenclatureResource extends Resource {
    // This resources has a fixed path since this nomenclature item is being
    // deprecated and will be removed in the future.
    basePath: string = 'nomenclatures/types/44/items/';

    objectPath: string = 'nomenclatures/types/44/items/{ident}/';
}
